import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThreeDotsHorizontal = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 10,
	viewBox: "0 0 16 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.7852 5.4C11.7852 4.73726 12.349 4.2 13.0445 4.2H13.0521C13.7476 4.2 14.3115 4.73726 14.3115 5.4C14.3115 6.06274 13.7476 6.6 13.0521 6.6H13.0445C12.349 6.6 11.7852 6.06274 11.7852 5.4Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.73438 5.4C6.73438 4.73726 7.29822 4.2 7.99376 4.2H8.0013C8.69684 4.2 9.26069 4.73726 9.26069 5.4C9.26069 6.06274 8.69684 6.6 8.0013 6.6H7.99376C7.29822 6.6 6.73438 6.06274 6.73438 5.4Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.68359 5.4C1.68359 4.73726 2.24744 4.2 2.94298 4.2H2.95052C3.64606 4.2 4.20991 4.73726 4.20991 5.4C4.20991 6.06274 3.64606 6.6 2.95052 6.6H2.94298C2.24744 6.6 1.68359 6.06274 1.68359 5.4Z",
			fill: "currentColor"
		})
	]
});
export default SvgThreeDotsHorizontal;
